import { Box, Typography } from "@mui/material";

const canvasMinWidth = {
  compact: 520,
  standard: 620,
  large: 720,
};

function VisualTakeaway({ children }) {
  const text = String(children || "");
  const separatorIndex = text.indexOf(":");
  if (separatorIndex === -1) return text;

  return (
    <>
      <Box component="span" sx={{ fontWeight: 900, mr: 0.75 }}>
        {text.slice(0, separatorIndex + 1)}
      </Box>
      <Box component="span">
        {text.slice(separatorIndex + 1).trim()}
      </Box>
    </>
  );
}

export default function LearnVisualFrame({ title, takeaway, caption, size = "standard", takeawaySx, children }) {
  return (
    <Box
      component="figure"
      className="learn-visual"
      sx={{
        my: { xs: 3.5, md: 4.25 },
        mx: 0,
        p: { xs: 2, md: 2.5 },
        border: "1px solid rgba(34, 35, 37, 0.12)",
        borderRadius: 1,
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.78), rgba(255,255,255,0.58))",
        boxShadow: "0 16px 40px rgba(34, 35, 37, 0.06)",
      }}
    >
      {title ? (
        <Typography
          component="div"
          sx={{
            mb: 1.4,
            fontSize: { xs: 15, md: 16 },
            lineHeight: 1.35,
            fontWeight: 900,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
      ) : null}

      <Box
        className="learn-visual__canvas"
        sx={{
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          "& svg": {
            display: "block",
            width: "100%",
            minWidth: { xs: canvasMinWidth[size] || canvasMinWidth.standard, sm: 0 },
            height: "auto",
          },
        }}
      >
        {children}
      </Box>

      {takeaway ? (
        <Typography
          component="div"
          sx={{
            mt: 1.35,
            p: 1.35,
            borderLeft: "3px solid",
            borderColor: "primary.main",
            backgroundColor: "rgba(201, 176, 123, 0.10)",
            color: "text.primary",
            fontSize: 13.5,
            lineHeight: 1.55,
            fontWeight: 800,
            ...takeawaySx,
          }}
        >
          <VisualTakeaway>{takeaway}</VisualTakeaway>
        </Typography>
      ) : null}

      {caption ? (
        <Typography
          component="figcaption"
          sx={{
            mt: takeaway ? 1.6 : 1.25,
            fontSize: 13,
            lineHeight: 1.55,
            color: "text.secondary",
          }}
        >
          {caption}
        </Typography>
      ) : null}
    </Box>
  );
}
